import { FC, HTMLAttributes, useCallback, useEffect, useState } from 'react';

import { BadgeCheckIcon, InfoIcon } from '@components/common/Icons';
import cx from 'classnames';
import { SubscriptionPlanBenefit } from 'models/stack9/SubscriptionPlanBenefit';

import s from './SubscriptionPlanBenefits.module.css';

const SubscriptionPlanCardInfo: FC = ({ children }) => {
  const [visible, setVisible] = useState(false);

  const handleOnClick = useCallback(ev => {
    ev.nativeEvent.stopPropagation();
    setVisible(true);
  }, []);

  useEffect(() => {
    const setVisibleFalse = () => setVisible(false);
    document.addEventListener('click', setVisibleFalse);
    return () => {
      document.removeEventListener('click', setVisibleFalse);
    };
  });

  return (
    <div className="relative">
      <button
        onClick={handleOnClick}
        onMouseOver={handleOnClick}
        className="text-coral-100"
      >
        <InfoIcon className="h-5 w-5 text-coral-100" />
      </button>
      {visible && (
        <div className="absolute text-xs text-grey-80 top-full right-0 translate-x-[5px] translate-y-[5px] p-3 bg-white/95 border border-coral-100 rounded min-w-[200px]">
          <div className="caret rotate-45 h-3 w-3 absolute bottom-full right-2 translate-y-[6px] bg-white border-coral-100 border-t border-l" />
          {children}
        </div>
      )}
    </div>
  );
};

export interface SubscriptionPlanBenefitsProps
  extends HTMLAttributes<HTMLUListElement> {
  featuredText?: boolean;
  subscriptionPlanBenefits?: SubscriptionPlanBenefit[];
}
const SubscriptionPlanBenefits = ({
  featuredText,
  subscriptionPlanBenefits,
  ...props
}: SubscriptionPlanBenefitsProps) => {
  const iconColor = featuredText ? 'text-coral-100' : 'text-dark-blue-100';

  return (
    <ul {...props}>
      {subscriptionPlanBenefits?.map(subscriptionPlanBenefit => (
        <li
          className="flex items-center justify-between mb-3"
          key={subscriptionPlanBenefit.id}
        >
          <div className="flex items-center">
            <BadgeCheckIcon
              className={cx(iconColor, 'h-[30px] w-[30px] mr-2 flex-shrink-0')}
            />
            {subscriptionPlanBenefit.name}
          </div>
          {subscriptionPlanBenefit.information && (
            <SubscriptionPlanCardInfo>
              <div
                className={s.subscriptionPlanCardInfo}
                dangerouslySetInnerHTML={{
                  __html: subscriptionPlanBenefit.information,
                }}
              />
            </SubscriptionPlanCardInfo>
          )}
        </li>
      ))}
    </ul>
  );
};

export default SubscriptionPlanBenefits;
